<a [routerLink]="link"
   [style.aspectRatio]="(image?.aspectRatio??'1')?.replace(':','/')">
    <img [use]="image"
         fit="width"
         role="presentation"
         [srcset]="srcset"
         [size]="size?.length > 0 ? size : imgSize" />
    <div class="text-area">
        <span>{{ superText }}</span>
        <div class="cta-area">
            <span>{{ text }}</span>
            <app-svg *ngIf="arrow"
                     use="arrow-right"></app-svg>
        </div>
        <app-sticker [sticker]="stick"
                     desktop
                     *ngFor="let stick of sticker"></app-sticker>
    </div>
    <app-sticker [sticker]="stick"
                 mobile
                 *ngFor="let stick of sticker"></app-sticker>
</a>
